import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.state';
import { openDeleteConfirmationDialog } from 'src/app/shared/store/action-dialog/action-dialog.actions';
import {
  deleteFocusAreaConfig,
  loadAllFocusAreaConfigs,
} from '../../store/global-settings.actions';
import { RiskAssessmentConfigFormDialogComponent } from '../../components/risk-assessment-config-form-dialog/risk-assessment-config-form-dialog.component';

@Component({
  standalone: false,
  selector: 'app-risk-assessment-configs',
  templateUrl: './risk-assessment-configs.component.html',
  styleUrl: './risk-assessment-configs.component.scss',
})
export class RiskAssessmentConfigComponent {
  constructor(private store: Store<AppState>, private dialog: MatDialog) {
    this.store.dispatch(loadAllFocusAreaConfigs());
  }

  addFocusAreaConfig() {
    this.openFocusAreaConfigFormDialog();
  }

  editFocusAreaConfig(focusAreaConfigId: string) {
    this.openFocusAreaConfigFormDialog(focusAreaConfigId);
  }

  deleteFocusAreaConfig(focusAreaConfigId: string) {
    this.store.dispatch(
      openDeleteConfirmationDialog({
        onConfirm: () => {
          this.store.dispatch(deleteFocusAreaConfig({ focusAreaConfigId }));
        },
        description:
          'are you sure you want to delete the selected focus area config? you cannot undo this action.',
      })
    );
  }

  private openFocusAreaConfigFormDialog(
    focusAreaConfigId: string | null = null
  ) {
    const dialogRef = this.dialog.open(
      RiskAssessmentConfigFormDialogComponent,
      {
        panelClass: 'risk-assessment-config-form-dialog',
        closeOnNavigation: false,
        disableClose: true,
        maxWidth: 'unset',
        data: focusAreaConfigId,
      }
    );
    dialogRef.afterClosed().subscribe(() => {
      dialogRef.componentInstance.closeWindow();
    });
  }
}
